<template>
  <v-container class="align-center justify-center" style="width: 320px;">
    <v-alert class="mb-2" variant="outlined" type="success" border="top" v-if="loggedIn">
      Authenticated successfully
    </v-alert>
    <v-alert class="mb-2" variant="outlined" type="info" border="top" v-if="msLoading">
      <div class="d-flex align-center">
        <v-progress-circular size="20" width="2" color="#006D94" indeterminate class="mr-3"></v-progress-circular>
        <span>{{ msLoadingMessage }}</span>
      </div>
    </v-alert>
    <v-alert class="mb-2" variant="outlined" type="error" border="top" v-if="error">
      {{ message }}
    </v-alert>
    <v-card style="width: 100%;">
      <v-card-title class="text-h5">Login</v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field v-if="!passwordState" class="ma-1" hide-details="auto" label="E-Mail" type="email" outlined
            dense @input="onEmailInput" @keyup.enter="login_email"></v-text-field>
          <v-fade-transition>
            <v-text-field v-show="passwordState" class="ma-1" hide-details="auto" label="Password" type="password"
              outlined dense @input="onPasswordInput" @keyup.enter="login_password"></v-text-field>
          </v-fade-transition>
        </v-form>
      </v-card-text>
      <v-card-actions class="align-center justify-center w-100">
        <v-btn v-if="!passwordState" color="#002394" @click="login_email" variant="flat" class="w-100"
          block>Continue</v-btn>
        <v-fade-transition>
          <v-btn v-show="passwordState" color="#002394" @click="login_password" variant="flat" class="w-100"
            block>Login</v-btn>
        </v-fade-transition>
        <v-progress-circular size="small" color="#006D94" indeterminate></v-progress-circular>
      </v-card-actions>
      <v-card-text class="align-center justify-center w-100 mt-2">
        <span class="text-caption font-weight-thin">Or continue with</span>
      </v-card-text>
      <v-card-actions class="align-center justify-center w-100" style="margin-top: -1rem">
        <v-btn color="#002394" @click="login_microsoft" prepend-icon="mdi-microsoft" variant="outlined"
          class="w-100" :disabled="msLoading">Microsoft</v-btn>
        <v-progress-circular size="small" color="#006D94" indeterminate v-if="loading"></v-progress-circular>
      </v-card-actions>
      <v-divider class="ma-2 mt-4"></v-divider>
      <v-card-actions class="align-center justify-center w-100">
        <a class="text-caption" href="https://www.hamburgportconsulting.com/contact/">Can't login?</a>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../config.js';
import { msalInstance } from "../msalConfig.js";
import { useRoute, useRouter } from "vue-router";

export default {
  data() {
    return {
      email: '',
      password: '',
      error: false,
      loggedIn: false,
      loading: false,
      msLoading: false,
      msLoadingMessage: '',
      user: null,
      passwordState: false,
    };
  },
  mounted() {
    document.title = 'TIS Login'
    const route = useRoute();
    this.onInitMSAL();
    if (route.path === "/logout") {
      this.onLogout();
    }
    const error = this.$route.query.error;
    if (error) {
      this.error = true;
      this.loading = false;
      this.message = 'Error during signup. Please try again';
    }
  },
  methods: {
    async onInitMSAL() {
      await msalInstance.initialize();
      await msalInstance.handleRedirectPromise();
    },
    async onLogout() {
      const router = useRouter();
      localStorage.removeItem("token");
      await msalInstance.initialize();
      await msalInstance.logoutRedirect({
        postLogoutRedirectUri: `${config.baseURL}/login`
      });
      router.push("/login");
    },
    onPasswordInput(event) {
      this.password = event.target.value;
    },
    onEmailInput(event) {
      this.email = event.target.value;
    },
    login_email(event) {
      this.passwordState = true;
    },
    async login_password(event) {

      // check email address in backend
      this.loading = true;

      if (this.email === '' || this.email === undefined || this.password === '' || this.password === undefined) {
        this.error = true;
        this.loading = false;
        this.message = 'Please enter a valid email address / password';
      }
      else {
        axios.post(`${config.baseURL}/api/v1/login/`, {
          username: this.email,
          password: this.password,
        })
          .then(response => {
            setTimeout(() => {
              this.loggedIn = true;
              this.loading = false;
            }, 1000);
            setTimeout(() => {
              this.$emit('login-success');
              this.$router.push('/');
            }, 2000);
            this.error = false;
            const token = response.data.token;
            localStorage.setItem('token', token);

          })
          .catch(error => {
            this.error = true;
            this.loading = false;
            this.message = 'Could not authenticate. Please check email and password.';
            this.$emit('login-failed');
          });
      }
    },
    async login_microsoft(event) {

      this.loading = true;
      this.msLoading = true;
      this.msLoadingMessage = 'Opening Microsoft login...';
      this.error = false;

      try {
        await msalInstance.initialize();
        const loginRequest = {
          scopes: ["user.read", "Sites.ReadWrite.All"],
        };

        msalInstance.loginPopup(loginRequest).then(response => {
          this.msLoadingMessage = 'Verifying credentials...';
          const access_token = response.idToken;
          const username = response.account.username

          // Validate token
          axios.post(`${config.baseURL}/api/v1/ms-token-check/`, {
            access_token: access_token,
            username: username,
          })
            .then(response => {
              const is_valid = response.data.is_valid;
              const error = response.data.error;
              if (is_valid && !error) {
                this.msLoadingMessage = 'Login successful! Redirecting...';
                const token = response.data.token;
                const is_newly_created = response.data.created;
                localStorage.setItem('token', token);
                this.$emit('login-success');

                setTimeout(() => {
                  this.msLoading = false;
                  this.loggedIn = true;
                  if (is_newly_created) {
                    this.$router.push({ path: '/signup', query: { email: username } });
                  }
                  else {
                    this.$router.push('/');
                  }
                }, 500);
              }
              else {
                const message = response.data.message;
                this.error = true;
                this.loading = false;
                this.msLoading = false;
                this.message = message
                this.$emit('login-failed');
              }
            })
            .catch(e => {
              this.error = true;
              this.loading = false;
              this.msLoading = false;
              this.message = 'Could not verify credentials. Please try again.';
              this.$emit('login-failed');
              console.debug(e)
            });
        }
        ).catch(e => {
          this.error = true;
          this.loading = false;
          this.msLoading = false;
          this.message = 'The login was cancelled';
          this.$emit('login-failed');
          console.debug(e)
        }
        );
      }
      catch (error) {
        this.error = true;
        this.loading = false;
        this.msLoading = false;
        this.message = 'The login was cancelled';
        this.$emit('login-failed');
      }
    }
  },
  async login() {
    this.loading = true;
    this.error = false;
    this.loggedIn = false;
    try {
      await msalInstance.initialize();
      const loginRequest = {
        scopes: ["user.read"],
      };
      msalInstance.handleRedirectPromise().then((tokenResponse) => {
        console.debug(tokenResponse)
        let accountObj = null;
        if (tokenResponse !== null) {
          accountObj = tokenResponse.account;
          const id_token = tokenResponse.idToken;
          const access_token = tokenResponse.accessToken;

          console.debug(id_token)
          console.debug(access_token)
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (!currentAccounts || currentAccounts.length === 0) {
            // No user signed in
            return;
          } else if (currentAccounts.length > 1) {
            // More than one user signed in, find desired user with getAccountByUsername(username)
          } else {
            accountObj = currentAccounts[0];
          }
        }

        const username = accountObj.username;

      }).catch((error) => {
        handleError(error);
      });
      msalInstance.loginPopup(loginRequest).then(resp => { console.log(resp) });

      console.debug(tokenResponse)

      this.user = {
        name: tokenResponse.account.name,
        email: tokenResponse.account.username,
      };

      axios.post(`${config.baseURL}/api/v1/login/`, {
        username: tokenResponse.account.username,
        password: this.password,
        ms_sso: true,
      })
        .then(response => {
          setTimeout(() => {
            this.loggedIn = true;
            this.loading = false;
          }, 500);
          setTimeout(() => {
            this.$emit('login-success');
            this.$router.push('/');
          }, 500);
          this.error = false;
          const token = response.data.token;
          localStorage.setItem('token', token);

        })
        .catch(error => {
          this.error = true;
          this.loading = false;
          this.message = 'Could not authenticate. Please check email and password.';
          this.$emit('login-failed');
        });



    } catch (error) {
      console.error("Login fehlgeschlagen", error);
    }

    /*axios.post(`${config.baseURL}/api/v1/login/`, {
      username: this.email,
      password: this.password,
    })
      .then(response => {
        setTimeout(() => {
          this.loggedIn = true;
          this.loading = false;
        }, 1000);
        setTimeout(() => {
          this.$emit('login-success');
          this.$router.push('/');
        }, 2000);
        this.error = false;
        const token = response.data.token;
        localStorage.setItem('token', token);
   
      })
      .catch(error => {
        this.error = true;
        this.loading = false;
        this.message = 'Could not authenticate. Please check email and password.';
        this.$emit('login-failed');
      });*/
  },
};
</script>